import types from '../../types';

const currencies = (
  state = { loading: true, assets: null, pairs: null, top_pairs: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_PAIRS_START:
      return { ...state, loading: true };

    case types.GET_PAIRS_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_PAIRS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default currencies;
